import * as React from "react";

import { MainLayout } from "../../../layouts";
import ProductCarousel from "../../ProductCarousel";
import Price from "../../../routes/Price";
import Team from "../../Team";
import TestimonialsCarousel from "../../TestimonialsCarousel";
import Functions from "./FunctionsContainer";
import Portfolio from "../../PortfolioCarousel";
import Panel from "./Panel";

import "./LandingPage.css";

export interface LandingPageProps {}

const LandingPage = (props: LandingPageProps): JSX.Element => (
  <MainLayout id="home" className="landing-page">
    <Panel nextSectionId="features" className="banner">
      <ProductCarousel />
    </Panel>
    <Panel nextSectionId="portfolio" className="features">
      <Functions />
    </Panel>
    <Panel nextSectionId="products" className="portfolio">
      <Portfolio />
    </Panel>
    <Panel nextSectionId="testimonials" className="price">
      <Price />
    </Panel>
    <Panel nextSectionId="team" className="testimonials">
      <TestimonialsCarousel />
    </Panel>
    <Panel className="team">
      <Team />
    </Panel>
  </MainLayout>
);

export default LandingPage;



// WEBPACK FOOTER //
// ./src/routes/LandingPage/components/LandingPage.tsx